<template>
  <div class="container">
    <BLoading :active.sync="longGrass.loadingStatus.isLoading" />

    <div v-if="!longGrass.loadingStatus.isLoading" class="columns">
      <main class="column is-6 long-grass-report">
        <LgHeaderSection :completed-on="longGrass.scheduleEventStatusSetAt" />

        <LgJobImagesSection :images="longGrass.images" />

        <LgPricingSection
          :mowing-cycle="mowingCycle"
          :lg-price="longGrass.lgPrice"
          :original-price="longGrass.originalPrice"
          :tax="longGrass.tax"
          :trust-fee="longGrass.trustFee"
          :total="longGrass.total"
          :long-grass-label="longGrass.label"
          :with-foot-notes="false"
        />
        <footer>
          <template v-if="!hasDispute">
            <p test-id="long_grass_fee_report-policy_with_revisit">
              {{ t('longGrass.longGrassReport.longGrassPolicy.revisitPreviouslyAccepted') }}
              <RouterLink :to="{ name: 'LongGrassPolicy' }">
                {{ t('longGrass.longGrassReport.longGrassPolicy.title') }} </RouterLink
              >.
            </p>
            <p test-id="long_grass_fee_report-policy_explanation">
              {{ t('longGrass.longGrassReport.longGrassPolicy.disputeExplanation') }}
            </p>
          </template>
          <template v-if="isDisputable">
            <p test-id="long_grass_fee_report-dispute">
              <RouterLink test-id="dispute_view_link" :to="{ name: 'LongGrassDispute' }">
                {{ t('longGrass.longGrassReport.longGrassPolicy.disputeClaim') }}
              </RouterLink>
            </p>
          </template>
          <LgDisputeMessage v-if="hasDispute" :dispute="longGrass.dispute" />
        </footer>
      </main>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LgDisputeMessage from '../components/LgDisputeMessage.vue';
import LgPricingSection from '../components/LgPricingSection.vue';
import LgJobImagesSection from '../components/LgJobImagesSection.vue';
import LgHeaderSection from '../components/LgHeaderSection.vue';
import { themedComponentMixin } from '@/mixins';
import { LONG_GRASS__GET } from '@/store/types';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'LongGrassFeeReportView',
  components: { LgHeaderSection, LgJobImagesSection, LgPricingSection, LgDisputeMessage },
  mixins: [themedComponentMixin],
  computed: {
    ...mapState(['longGrass', 'serviceHistory']),
    propertyId() {
      return this.$route.params.property_id;
    },
    reportId() {
      return this.$route.params.report_id;
    },
    scheduleId() {
      return this.$route.params.schedule_id;
    },
    scheduleEventId() {
      return this.$route.params.scheduleevent_id;
    },
    isDisputable() {
      return this.longGrass.dispute.isDisputable;
    },
    hasDispute() {
      return !!this.longGrass.dispute.status;
    },
    mowingCycle() {
      return lsLongGrassHelpers.getMowingCycle(this.serviceHistory.schedule);
    },
  },
  async beforeMount() {
    const { propertyId, reportId, scheduleId, scheduleEventId } = this;
    await this.getLongGrassFee({ propertyId, reportId, scheduleId, scheduleEventId });
  },
  methods: {
    ...mapActions({ getLongGrassFee: LONG_GRASS__GET }),
  },
};
</script>
<style lang="scss" scoped>
.long-grass-report {
  footer {
    p {
      & ~ p {
        margin-top: 1rem;
      }
    }
    section {
      padding: 0 0 3rem;
    }
  }
}
</style>
